import { FC } from 'react'
import { KTIcon } from '../../../../../../../_metronic/helpers'
import { InvoicePaymentForm } from '../../core/_models'
import {FieldHelpLabel} from '../../../../../../../_metronic/helpers/components/FieldHelp'

type props = {
  title: string,
  paymentItem: {
    paymentItem: InvoicePaymentForm | null | undefined,
    setPaymentItem: React.Dispatch<React.SetStateAction<InvoicePaymentForm | null | undefined>>
  }
}
const InvoicePaymentEditModalHeader: FC<props> = ({ title, paymentItem }) => {

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder text-primary'>
        <FieldHelpLabel label={title} helpKey='section.payments' />
      </h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-invoices-modal-action='close'
        onClick={() => paymentItem.setPaymentItem(undefined)}
        style={{ cursor: 'pointer' }}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export { InvoicePaymentEditModalHeader }
